import { createSvgIcon } from '@mui/material';
import React from 'react';

export const AddNote = createSvgIcon(
    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M2.25 13.5H11.25V12H2.25V13.5ZM2.25 4.5V6H15.75V4.5H2.25ZM2.25 9.75H15.75V8.25H2.25V9.75Z"
            fill="currentColor"
        />
        <path
            d="M15.5 10.75V13H17.75V14H15.5V16.25H14.5V14H12.25V13H14.5V10.75H15.5Z"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="0.25"
        />
    </svg>,
    'AddNote'
);
